// extracted by mini-css-extract-plugin
export var background = "_5x-0";
export var container = "_5x-1";
export var contentItem = "_5x-7";
export var extendedWarranty = "_5x-5";
export var link = "_5x-d";
export var modal = "_5x-b";
export var modalCloseButton = "_5x-9";
export var modalContent = "_5x-3";
export var modalContentMain = "_5x-6";
export var modalImageLogo = "_5x-8";
export var modalLogo = "_5x-a";
export var modalSideImage = "_5x-4";
export var preview = "_5x-c";
export var redoModal = "_5x-2";